import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: '../templates/alert.component.html'
})
export class AlertsComponent {

  constructor(private alertService: AlertService) {
  }

  closeAlert(index) {
    this.alertService.remove(index);
  };

  getAlertsList() {
    return this.alertService.alertsList;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/alert/components/scripts/alert.component.ts